export const STOP_TRACKING_PAGE_LOADER = 'STOP_TRACKING_PAGE_LOADER';
export const START_TRACKING_PAGE_LOADER = 'START_TRACKING_PAGE_LOADER';

const stopTrackingPageLoaderAction = () => ({
  type: STOP_TRACKING_PAGE_LOADER,
});

const startTrackingPageLoaderAction = () => ({
  type: START_TRACKING_PAGE_LOADER,
});

export function stopCommonLoader() {
  return (dispatch) => {
    dispatch(stopTrackingPageLoaderAction());
  };
}

export function startCommonLoader() {
  return (dispatch) => {
    dispatch(startTrackingPageLoaderAction());
  };
}
